import { LoadingButton } from '@mui/lab';

export default LoadingButton;
